module.exports = function() {
  return new Worker("/" + "monaco-linter.8aa86fbc.worker.js");
};